/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { FormBankPagedRequest } from '../models/FormBankPagedRequest';
import type { FormCategory } from '../models/FormCategory';
import type { FormTable } from '../models/FormTable';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class FormBankService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param formId 
     * @param tenantId 
     * @param companyKey 
     * @returns FormTable Success
     * @throws ApiError
     */
    public cloneToFormLibrary(
formId: string,
tenantId: string,
companyKey: string,
): Observable<FormTable> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/form-bank/clone-to-form-library/{formId}/{tenantId}/{companyKey}',
            path: {
                'formId': formId,
                'tenantId': tenantId,
                'companyKey': companyKey,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public getList(
requestBody?: FormBankPagedRequest,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/form-bank/get-all',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @returns FormCategory Success
     * @throws ApiError
     */
    public getCategoriesList(): Observable<Array<FormCategory>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/form-bank/get-category-list',
        });
    }

}
